import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerShareLink(name: string, link: string) {
	logGoogleTagManagerEvent({
		event: 'cogvio.shareLink',
		shareLink: { name, link },
	});
}
